// Command prefixes for autonomous modes
const RALPH_COMMAND = "/ona:ralph";
const SPEC_COMMAND = "/ona:spec";
const REVIEW_COMMAND = "/ona:review";

export type AgentModePrefix = "ralph" | "spec" | "review" | "agent";

/**
 * Parses agent mode command prefix from content.
 * Returns both the detected mode and the content with prefix stripped.
 */
export function parseAgentModePrefix(content: string): { mode: AgentModePrefix; strippedContent: string } {
    // Check Ralph prefix
    if (content.startsWith(RALPH_COMMAND)) {
        const remainder = content.slice(RALPH_COMMAND.length);
        if (remainder === "" || remainder.startsWith(" ") || remainder.startsWith("\n")) {
            return { mode: "ralph", strippedContent: remainder.trimStart() };
        }
    }
    // Check Spec prefix
    if (content.startsWith(SPEC_COMMAND)) {
        const remainder = content.slice(SPEC_COMMAND.length);
        if (remainder === "" || remainder.startsWith(" ") || remainder.startsWith("\n")) {
            return { mode: "spec", strippedContent: remainder.trimStart() };
        }
    }
    // Check Review prefix
    if (content.startsWith(REVIEW_COMMAND)) {
        const remainder = content.slice(REVIEW_COMMAND.length);
        if (remainder === "" || remainder.startsWith(" ") || remainder.startsWith("\n")) {
            return { mode: "review", strippedContent: remainder.trimStart() };
        }
    }
    return { mode: "agent", strippedContent: content };
}
